export const blockSmoother = () => {
	document.body.classList.add("overflow-hidden");
	if (window.scrollSmoother?.instance) {
		window.scrollSmoother.instance.kill();
	}
};

export const resetSmoother = () => {
	document.body.classList.remove("overflow-hidden");
	if (window.scrollSmoother?.instance) {
		window.scrollSmoother.init();
		window.scrollSmoother.instance.paused(true);
		setTimeout(() => {
			window.scrollSmoother.instance.paused(false);
		}, 800);
	}
};
